import { selector } from 'recoil';
import { uniqBy } from 'lodash';

import { getActiveClients, getClients, getClientsProfile, getClientSuccessOwner } from '../../repositories/HttpRepository';

export const selectorClientsActive = selector({
  key: 'selector/clients/active',
  get: async ({ get }) => {
    const response = await getActiveClients();
    if (!response.ok) return [];
    return uniqBy(response.data, 'client_id');
  },
});

export const selectorClientsProfile = selector({
  key: 'selector/clients/profile',
  get: async ({ get }) => {
    const response = await getClientsProfile();
    if (!response.ok) return [];
    return response.data;
  },
});

export const selectorClients = selector({
  key: 'selector/clients',
  get: async ({ get }) => {
    const response = await getClients();
    if (!response.ok) return [];
    return response.data;
  },
});

export const selectorClientSuccessOwner = selector({
  key: 'selector/client/success/owner',
  get: async () => {
    const response = await getClientSuccessOwner();

    return response.status === 200 ? response.data : [];
  },
});
